module.exports = __webpack_public_path__ + "static/media/couple-in-restaurant.01211903.jpg";